export const buildFormData = (initData, formData = new FormData(), parentKey = '') => {
    const data = Object.assign({}, initData)



    //TODO: fix this method error: Object(...) is not a function
    for (let key in data) {
        // console.log(key, data[key], typeof data[key], value instanceof FileList);

        if (!data.hasOwnProperty(key)) continue

        const value = data[key];
        const formKey = parentKey ? `${parentKey}[${key}]` : key;

        if (value instanceof FileList) {
            for (let file of value) {
                formData.append(`${formKey}[]`, file);
            }
            continue
        }

        if (value instanceof File) {
            formData.append(formKey, value);
            continue
        }

        if (Array.isArray(value)) {

            value.forEach((item) => {
                formData.append(`${formKey}[]`, item);
            })

            continue
        }

        if (typeof value === 'object' && value !== null) {
            buildFormData(value, formData, formKey);

            continue
        }

        formData.append(formKey, value !== undefined ? value : '');
    }
    return formData;
};
